module.exports = __webpack_public_path__ + "static/disney_posters-a0f1342420af6abe03bfce0b355a3d28.jpg";